import { defineMessages } from "react-intl";

export const commonMessages = defineMessages({
  logout: {
    id: "logout",
    defaultMessage: "Log Out"
  },
  revertToAdmin: {
    id: "revertToAdmin",
    defaultMessage: "Revert to Admin"
  },
  revertToSuperadmin: {
    id: "revertToSuperadmin",
    defaultMessage: "Revert to OneLogin Admin"
  },
  showOptions: {
    id: "showOptions",
    defaultMessage: "Show Options"
  }
});
